import { useLocation } from 'react-router';
import env from '~/env';

export const useCurrentUrl = () => {
  const { pathname, search } = useLocation();
  const baseUrl = env?.APP_BASE_URL;

  if (!baseUrl) {
    throw new Error('getReturnToUrl: env.APP_BASE_URL could not be accessed');
  }

  return { currentUrl: `${baseUrl}${pathname}${search}` };
};
